import { render, staticRenderFns } from "./to-do-collect.vue?vue&type=template&id=4aedc96c&scoped=true"
import script from "./to-do-collect.vue?vue&type=script&lang=js"
export * from "./to-do-collect.vue?vue&type=script&lang=js"
import style0 from "./to-do-collect.vue?vue&type=style&index=0&id=4aedc96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aedc96c",
  null
  
)

export default component.exports